import { useEffect, useState } from 'react';
import { HeaderComponent, LoaderComponent, SidebarComponent } from '../components';
import { Menus } from '../constants/menus-constant';
import { Outlet, useNavigate, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { AuthLayoutBody, AuthLayoutContainer, AuthLayoutWrapper } from '../styles/global-styles';
import { permissionsHelper } from '../helpers/permissions';

const Logo = {
  src: '/logo.webp',
  alt: 'Open ACS'
};

const AuthLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { isAuthenticated, user } = useSelector((state) => state.loginUserReducer);
  const permissions = permissionsHelper(user);

  const MenuList = Menus({ user });

  const [loading, setLoading] = useState(true);

  // const unCheckPermissions = [
  //   { id: 0, name: 'home', pageUrl: '/app/home', menuLabel: 'home', parentId: -1, type: 'menu' },
  // ];
  const unCheckRoutes = ['/app/home', '/user-operations/changepassword'];
  // const unCheckRoutes = ['/app/home', '/user-operations/changepassword', '/app/card-status-management', '/app/card-status-management/view-list', '/app/card-status-management/file-import-logs', '/app/card-status-management/file-import-audit-logs'];

  const checkPermissions = () => {
    if (user?.firstLogin) {
      navigate("/user-operations/changepassword");
      return setLoading(false);
    }

    if (unCheckRoutes.includes(location.pathname)) {
      return setLoading(false);
    }

    if (user?.permissions?.some(permission => permission.pageUrl === location.pathname)) {
      return setLoading(false);
    }

    const defaultPage = MenuList[0]?.to || "/";
    navigate(defaultPage);
  };

  useEffect(() => {
    if (isAuthenticated === undefined) {
      setLoading(true);
    } else if (isAuthenticated) {
      checkPermissions();
    } else {
      navigate("/login");
    }
  }, [isAuthenticated, location.pathname, navigate, user]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return <LoaderComponent />;
  }

  return (
    <AuthLayoutWrapper>
      <HeaderComponent logo={Logo} />

      <AuthLayoutContainer>
        {
          user?.permissions && user?.permissions.length > 0 &&
           <SidebarComponent menus={MenuList} permissions={permissions} />
        }
        <AuthLayoutBody className='update-layout-body'>
          <Outlet />
        </AuthLayoutBody>
      </AuthLayoutContainer>
    </AuthLayoutWrapper>
  );
};

export default AuthLayout;